import api from './index';

// ========== 商品管理 ==========
export const listProducts = (params) => api.get('/web/mall/product/list', { params });
export const saveProduct = (data) => api.post('/web/mall/product/save', data);
export const updateProduct = (data) => api.put('/web/mall/product/update', data);
export const updateProductStatus = (id, status) => api.put('/web/mall/product/status', null, { params: { id, status } });
export const deleteProduct = (id) => api.delete('/web/mall/product/delete', { params: { id } });
export const listProductTypes = () => api.get('/web/mall/product/type/list');
export const saveProductType = (data) => api.post('/web/mall/product/type/save', data);

// ========== 订单管理 ==========
export const listOrders = (params) => api.get('/web/mall/order/list', { params });
export const getOrderDetail = (orderNo) => api.get('/web/mall/order/detail', { params: { orderNo } });
export const shipOrder = (orderNo, logisticsCompany, trackNo) =>
    api.put('/web/mall/order/ship', null, { params: { orderNo, logisticsCompany, trackNo } });
export const getDashboardStats = () => api.get('/web/mall/order/stat/dashboard');
